module.exports = __webpack_public_path__ + "static/media/Pasajeros.d304d149.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Pasajeros.svg
// module id = 2065
// module chunks = 0